import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useOverlaySSE from './useOverlaySSE';
import api, { formatRupiah } from '../../lib/api';
import './overlay.css';

export default function OverlayLeaderboard() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [rows, setRows] = useState([]);

  const period = searchParams.get('period') || 'alltime';
  const limit = parseInt(searchParams.get('limit') || '5');
  const customTitle = searchParams.get('title') || 'Top Supporter';
  const accentColor = searchParams.get('accent') || '#FF6B35';

  const fetchLeaderboard = useCallback(async () => {
    try {
      const res = await api.get(`/overlay/leaderboard/${token}`, { params: { period, limit } });
      setRows(res.data || []);
    } catch {}
  }, [token, period, limit]);

  useEffect(() => { fetchLeaderboard(); }, [fetchLeaderboard]);

  const handleEvent = useCallback((event) => {
    if (event.type === 'donation') {
      fetchLeaderboard();
    }
  }, [fetchLeaderboard]);

  useOverlaySSE(token, handleEvent);

  if (rows.length === 0) return <div className="overlay-container" style={{ '--ov-accent': accentColor }} />;

  const periodLabels = { daily: 'Hari Ini', weekly: 'Minggu Ini', monthly: 'Bulan Ini', alltime: 'Sepanjang Masa' };

  return (
    <div className="overlay-container" style={{ '--ov-accent': accentColor }}>
      <div className="leaderboard-container">
        <div className="leaderboard-card">
          <div className="leaderboard-header">
            👑 {customTitle}
          </div>
          {rows.map((r) => (
            <div key={r.rank} className="leaderboard-row">
              <div className={`leaderboard-rank ${r.rank <= 3 ? `top-${r.rank}` : ''}`}>
                {r.rank <= 3 ? ['🥇', '🥈', '🥉'][r.rank - 1] : `#${r.rank}`}
              </div>
              <div className="leaderboard-name">
                {r.name}
              </div>
              <div className="leaderboard-amount">{formatRupiah(r.total)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
